// import getMe from '../data/fetch/getMe';

export function setMobileSidebarVisibility(isVisible) {
  return {
    type: 'SET_MOBILE_SIDEBAR_VISIBILITY',
    value: isVisible,
  };
}

// export function setGlobalIsLoading(isLoading) {
//   throw new Error('setGlobalIsLoading is deprecated.  use runtime action.');
//   // return {
//   //   type: 'SET_GLOBAL_LOADING_INDICATOR',
//   //   value: isLoading,
//   // };
// }

export function setMeData(userData) {
  return {
    type: 'SET_ME_DATA',
    value: userData,
  };
}

// export function getUserData(siteId, fetch) {
//   return dispatch =>
//     getMe(siteId, fetch).then(response => response.json()).then(json => {
//       dispatch({
//         type: 'SET_ME_DATA',
//         value: json.data.me,
//       });
//     });
// }

export function setLocale(loacleId) {
  return {
    type: 'SET_LOCALE',
    value: loacleId,
  };
}

export function setCart(cart) {
  return {
    type: 'SET_CART',
    value: cart,
  };
}

export function setWishlist(wishlist) {
  return {
    type: 'SET_WISHLIST',
    value: wishlist,
  };
}



// WEBPACK FOOTER //
// ./src/actions/SessionActions.js